import type React from 'react'

import css from './Loading.module.scss'

const Loading: React.FC = () => {
  return (
    <div className={css.container}>
      <div className={css.loading}>
        <span />
        <span />
        <span />
      </div>
    </div>
  )
}

export default Loading
